import { useNavigate, useLocation, matchPath } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../helpers/useAuth';
import { useEffect, useState } from 'react';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, memberType, logout } = useAuth();
  
  const [viewingName, setViewingName] = useState('');

  const sessionMemberType = sessionStorage.getItem('member_type');
  const sessionConsultancyName = sessionStorage.getItem('consultancy_name');

  const match = matchPath({ path: "/consultant-dashboard/:encodedId" }, location.pathname);
  const isConsultantRoute = !!match;

  useEffect(() => {
    const handleUpdateName = (e) => {
      setViewingName(e.detail);
    };

    window.addEventListener('updateConsultancyHeader', handleUpdateName);
    
    if (!isConsultantRoute) {
      setViewingName('');
    }

    return () => window.removeEventListener('updateConsultancyHeader', handleUpdateName);
  }, [isConsultantRoute]);

  const handleLogout = () => {
    toast(
      (t) => (
        <div className="flex flex-col gap-3 w-80">
          <div className="font-medium text-white">Are you sure you want to logout?</div>
          <div className="flex justify-end gap-3 mt-1">
            <button onClick={() => toast.dismiss(t.id)} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition">Cancel</button>
            <button onClick={() => { toast.dismiss(t.id); performLogout(); }} className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition">Yes, Logout</button>
          </div>
        </div>
      ),
      {
        duration: 6000,
        position: "top-center",
        style: { background: '#1f2937', border: '1px solid #ef4444', padding: '16px', color: '#ffffff', maxWidth: '380px' },
      }
    );
  };

  const performLogout = () => {
    logout();
    toast.success('Logged out successfully 👋', { duration: 3000, position: "top-center" });
    navigate('/login', { replace: true });
  };

  return (
    <header className="bg-white shadow px-6 py-4 flex justify-between items-center">
      <h1 className="text-2xl font-semibold text-gray-800">
        {sessionMemberType === 'Consultancy' && (
          <span className="text-indigo-600 uppercase tracking-tight font-bold">{sessionConsultancyName || 'My Consultancy'}</span>
        )}

        {sessionMemberType === 'Admin' && isConsultantRoute && (
          <span className="text-orange-600 uppercase tracking-tight font-bold">
            {viewingName || 'Loading...'}
          </span>
        )}

      </h1>

      <div className="flex items-center gap-6">
        <div className="flex flex-col items-end">
          <div className="text-sm font-medium text-gray-700">Welcome, <span className="text-blue-700">{user || 'User'}</span></div>
          {memberType && <div className="text-xs text-gray-500">Role: {memberType}</div>}
        </div>
        <button onClick={handleLogout} className="text-sm font-medium text-red-600 hover:text-red-800 transition-colors flex items-center gap-1 px-3 py-2 border border-red-200 rounded-md hover:bg-red-50">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;